<script>
  // Interactive on/off toggle cell — the ONE canonical way an on/off lifecycle state
  // (active, enabled…) appears in a table. Never a read-only badge for one entity and
  // a toggle-in-actions for another. Flips the column's boolean field by calling
  // `onToggle(row, newValue)`, which the page wires to its router.patch handler
  // (its existing `toggleActive(item, active)` matches this signature directly).
  let { value, row, column, onToggle } = $props()
</script>

<input
  type="checkbox"
  class="toggle toggle-sm toggle-primary align-middle"
  checked={!!value}
  disabled={!onToggle}
  aria-label={column.label || String(column.field)}
  onchange={() => onToggle?.(row, !value)}
/>
